import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { UserService } from './user.service';

declare var dataLayer: any;

@Injectable()
export class DcGtmService {
  constructor(public router: Router, public userService: UserService) {
  }

  init() {
    this.initDataLayer();
    this.trackRouteChange();
  }

  initDataLayer() {
    if (typeof dataLayer !== 'undefined' && dataLayer) {
      dataLayer = (<any>window).dataLayer = (<any>window).dataLayer || [];
    }
  }

  trackRouteChange() {
    this.router.events
    .filter(event => event instanceof NavigationEnd)
    .subscribe((event: NavigationEnd) => {
      this.pageTrack();
    });
  }

  pageTrack() {
    if (typeof dataLayer !== 'undefined' && dataLayer) {
      this.userService.getProfile()
      .then((user) => {
        let toPush = {
          'User': user['email'],
          'event': 'transactionComplete'
        };
        dataLayer.push(toPush);
      });
    }
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/gtm.service.ts